<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { DropdownMenuSubTrigger, type DropdownMenuSubTriggerProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<DropdownMenuSubTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuSubTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'flex cursor-default items-center justify-between rounded-xs px-2 py-1.5 text-sm outline-hidden select-none focus:bg-slate-100 data-[state=open]:bg-slate-100',
        props.class,
      )
    "
  >
    <slot />
    <i class="fa-light fa-chevron-right"></i>
  </DropdownMenuSubTrigger>
</template>
